import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { createUseStyles } from "react-jss";
import SearchFilter from "./components/SearchFilter";
import { OutletSearchContent } from "../../../services/dto/outlet";

const useStyles = createUseStyles({
  container: {
    padding: "20px",
    background: "#fff",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "50px",
  },
  searchContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: 60,
  },
  tableContainer: {
    marginTop: "20px",
  },
  addButton: {
    borderColor: "#1890ff",
    color: "#1890ff",
    "&:hover": {
      borderColor: "#40a9ff",
      color: "#40a9ff",
    },
  },
  link: {
    color: "#1890ff",
    cursor: "pointer",
    textDecoration: "underline",
  },
  footerContainer: {
    display: "flex",
    justifyContent: "flex-end", // Align to the left below Add button
    marginTop: "20px", // Space from the table
  },
});

export default function OutletSearch() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [data, setData] = useState<OutletSearchContent[]>([]);
  const [multipleDeleteData, setMulitpleDeleteData] = useState<
    OutletSearchContent[]
  >([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const columns = [
    {
      title: "Kode",
      dataIndex: "code",
      key: "code",
      render: (text: string, record: any) => (
        <span
          className={classes.link}
          onClick={() =>
            navigate(`/outlet/detail`, { state: { data: record } })
          }
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.code.localeCompare(b.code),
    },
    {
      title: "Nama",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <EditOutlined
            onClick={() =>
              navigate(`/outlet/edit/input`, { state: { data: record } })
            }
          />
          <DeleteOutlined
            onClick={() =>
              navigate(`/outlet/delete/review`, { state: { data: record } })
            }
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: OutletSearchContent[]
  ) => {
    setSelectedRowKeys(newSelectedRowKeys as string[]);
    setMulitpleDeleteData(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <h2>Outlet</h2>
        <Button
          ghost={true}
          type="primary"
          onClick={() => navigate("/outlet/add/input")}
          className={classes.addButton}
        >
          Add
        </Button>
      </div>
      <SearchFilter setData={setData} initSearch={true} />
      <div className={classes.tableContainer}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="code"
          rowSelection={rowSelection}
          scroll={{ x: true }}
          pagination={{
            position: ["bottomRight"],
            pageSizeOptions: ["10", "50", "100"],
            showSizeChanger: true,
            defaultPageSize: 10,
          }}
        />
      </div>
      <div className={classes.footerContainer}>
        {selectedRowKeys.length > 0 && (
          <Button
            type="primary"
            onClick={() =>
              navigate("/outlet/multiple-delete/review", {
                state: { data: multipleDeleteData },
              })
            }
            danger={true}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  );
}
